<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To my Daughters and Son,</p>
<p class="ded1">of whom I’m infinitely proud!</p>
<p class="ded2">Dawn Michelle Nance</p>
<p class="ded1">Bridgitte Cathleen Nance</p>
<p class="ded1">Christopher Sean Nance</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1aafd756